import { useState } from "react";
import {
  useAsyncDebounce,
  // UseGlobalFiltersState,
  // UseGlobalFiltersInstanceProps,
} from "react-table";

import { IoSearchSharp } from "react-icons/io5";
import { BiX } from "react-icons/bi";

/*
interface GlobalFilterTextFieldProps<T extends object> {
  globalFilter: UseGlobalFiltersState<T>['globalFilter'];
  setGlobalFilter: UseGlobalFiltersInstanceProps<T>['setGlobalFilter'];
}

function GlobalFilterTextField<T extends object>({
  globalFilter,
  setGlobalFilter,
}: GlobalFilterTextFieldProps<T>
*/

function GlobalFilterTextField({ globalFilter, setGlobalFilter }) {
  const [value, setValue] = useState(globalFilter || "");

  const onChange = useAsyncDebounce((newValue) => {
    setGlobalFilter(newValue || undefined);
  }, 500);

  const onClear = useAsyncDebounce(() => {
    setGlobalFilter(undefined);
  }, 500);

  return (
    <div className="tw-relative tw-w-60 md:tw-w-72">
      <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-2">
        <IoSearchSharp className="tw-h-5 tw-w-5" />
      </div>

      <button
        className={`tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-bg-transparent tw-rounded-full tw-outline-none tw-border-0 tw-pr-2 focus:tw-outline-none ${
          value ? "tw-opacity-100" : "tw-opacity-50"
        }`}
        type="button"
        onClick={() => {
          if (!value || value === "") return;
          setValue("");
          onClear();
        }}
      >
        <BiX className="tw-h-5 tw-w-5" />
      </button>

      <input
        id="global-filter-text-field"
        type="text"
        className="form-control tw-pl-8 tw-placeholder-"
        placeholder="Search by any field"
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
          onChange(event.target.value);
        }}
      />
    </div>
  );
}

export default GlobalFilterTextField;
